export const bookingAvailabilityActionTypes = {
  API_RESPONSE_SUCCESS: 'API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: 'API_RESPONSE_ERROR',
  GET_AVAILABLE_ROOMS: 'GET_AVAILABLE_ROOMS'  
};

export interface bookingAvailabilityReducerState {
  booked_rooms: any[]; // Timeline of user/system messages 
  available_rooms: any[];
  loading: boolean;
  error: string | null;
}
